import { render } from "./AppSubmenu.vue?vue&type=template&id=c0fc5654&ts=true"
import script from "./AppSubmenu.vue?vue&type=script&lang=ts"
export * from "./AppSubmenu.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__